// extracted by mini-css-extract-plugin
module.exports = {"breakpoint-tablet":"600px","breakpoint-laptop":"1024px","breakpoint-desktop":"1600px","container":"default_container__U1Zx_","inputs":"default_inputs__kkMhZ"};